module.exports = __webpack_public_path__ + "img/qr.354ea369.webp";